import { AxiosResponse } from 'axios';
import { call, put, select, takeLatest } from 'redux-saga/effects';

import { getBookmarksUrl, setBookmarkUrl } from 'config/api';

import { selectConsentMask } from 'store/config/selectors.ts';
import { selectAccountId } from 'store/user/selectors';

import NagraInstance from 'utils/axios/nagra/DefaultInstance';

import {
    deleteAllBookmarksFailure,
    deleteAllBookmarksRequest,
    deleteAllBookmarksSuccess,
    getBookmarksFailure,
    getBookmarksRequest,
    getBookmarksSuccess,
    setBookmark,
    setBookmarkFailure,
    setBookmarkRequest,
    setBookmarkSuccess,
} from './actions';
import { DELETE_ALL_BOOKMARKS, GET_BOOKMARKS, SET_BOOKMARK } from './constants';
import { Bookmark, BookmarksResponse } from './reducer.types';

function* onGetBookmarks() {
    try {
        yield put(getBookmarksRequest());

        const accountId: string = yield select(selectAccountId);

        if (accountId) {
            const {
                data: { bookmarks },
            }: AxiosResponse<BookmarksResponse> = yield call(
                NagraInstance.get,
                getBookmarksUrl(accountId),
            );

            yield put(getBookmarksSuccess(bookmarks));
        }
    } catch (error) {
        yield put(getBookmarksFailure(error));
    }
}

function* onSetBookmark({
    payload: { bookmark: payload },
}: ReturnType<typeof setBookmark>) {
    try {
        yield put(setBookmarkRequest());

        const { data: bookmark }: AxiosResponse<Bookmark> = yield call(
            NagraInstance.put,
            setBookmarkUrl(payload.account, payload.contentId, payload.expires),
            payload,
            {
                headers: {
                    'nv-tenant-id': 'nagra',
                },
            },
        );

        yield put(setBookmarkSuccess(bookmark));
    } catch (error) {
        yield put(setBookmarkFailure(error));
    }
}

function* onDeleteAllBookmarks() {
    try {
        yield put(deleteAllBookmarksRequest());

        const accountId: string = yield select(selectAccountId);
        const consentMask = yield select(selectConsentMask);

        yield call(NagraInstance.delete, getBookmarksUrl(accountId), {
            headers: {
                'nv-tenant-id': 'nagra',
            },
            data: {
                metadata: {
                    consentMask,
                },
            },
        });

        yield put(deleteAllBookmarksSuccess());
    } catch (error) {
        yield put(deleteAllBookmarksFailure(error));
    }
}

export default [
    takeLatest(GET_BOOKMARKS, onGetBookmarks),
    takeLatest(SET_BOOKMARK, onSetBookmark),
    takeLatest(DELETE_ALL_BOOKMARKS, onDeleteAllBookmarks),
];
